import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

import axios from "axios";

const API_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

// ==========================
// FETCH MATRIMONY PROFILES
// ==========================
export const fetchMatrimonyProfiles =
  createAsyncThunk(
    "matrimony/fetchMatrimonyProfiles",
    async (
      user_id:
        | number
        | string
        | null = null,
      { rejectWithValue }
    ) => {
      try {
        const res = await axios.get(
          user_id
            ? `${API_URL}/matrimony/user`
            : `${API_URL}/matrimony`,
          user_id
            ? {
                params: {
                  user_id,
                },
              }
            : undefined
        );

        return res.data;
      } catch (error: any) {
        return rejectWithValue(
          error?.response?.data?.message ||
            "Failed to fetch matrimony profiles"
        );
      }
    }
  );

// ==========================
// FETCH MATRIMONY PROFILE BY ID
// ==========================
export const fetchMatrimonyProfileById =
  createAsyncThunk(
    "matrimony/fetchMatrimonyProfileById",
    async (
      id: number | string,
      { rejectWithValue }
    ) => {
      try {
        const res = await axios.get(
          `${API_URL}/matrimony/${encodeURIComponent(
            String(id)
          )}`
        );

        return res.data;
      } catch (error: any) {
        return rejectWithValue(
          error?.response?.data?.message ||
            "Failed to fetch matrimony profile"
        );
      }
    }
  );

interface MatrimonyState {
  profiles: any[];
  profile: any | null;
  loading: boolean;
  viewLoading: boolean;
  error: string | null;
}

const initialState: MatrimonyState = {
  profiles: [],
  profile: null,
  loading: false,
  viewLoading: false,
  error: null,
};

const matrimonySlice =
  createSlice({
    name: "matrimony",

    initialState,

    reducers: {
      clearMatrimonyProfile: (
        state
      ) => {
        state.profile = null;
      },

      resetMatrimonyError: (
        state
      ) => {
        state.error = null;
      },
    },

    extraReducers: (
      builder
    ) => {
      builder
        .addCase(
          fetchMatrimonyProfiles.pending,
          (state) => {
            state.loading = true;
            state.error = null;
          }
        )

        .addCase(
          fetchMatrimonyProfiles.fulfilled,
          (
            state,
            action
          ) => {
            state.loading = false;

            state.profiles =
              action.payload?.data ||
              [];
          }
        )

        .addCase(
          fetchMatrimonyProfiles.rejected,
          (
            state,
            action
          ) => {
            state.loading = false;
            state.profiles = [];

            state.error =
              action.payload as string;
          }
        )

        .addCase(
          fetchMatrimonyProfileById.pending,
          (state) => {
            state.viewLoading =
              true;

            state.error = null;
            state.profile = null;
          }
        )

        .addCase(
          fetchMatrimonyProfileById.fulfilled,
          (
            state,
            action
          ) => {
            state.viewLoading =
              false;

            state.profile =
              action.payload?.data ||
              null;
          }
        )

        .addCase(
          fetchMatrimonyProfileById.rejected,
          (
            state,
            action
          ) => {
            state.viewLoading =
              false;

            state.profile = null;

            state.error =
              action.payload as string;
          }
        );
    },
  });

export const {
  clearMatrimonyProfile,
  resetMatrimonyError,
} = matrimonySlice.actions;

export default matrimonySlice.reducer;
